import React, { memo, Fragment } from 'react'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import LOG from '../../logging/Logger'

const useStyles = makeStyles(theme => ({
  tabSection: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: '10px',
    paddingTop: '10px'
  }
}))

const SettingsPanel = memo(props => {
  LOG.debug('Render: SettingsPanel')

  const classes = useStyles()

  return (
    <Fragment>
      <Typography variant='h6' className={classes.tabHeader}>
        {props.title}
      </Typography>
      <div className={classes.tabSection}>{props.children}</div>
    </Fragment>
  )
})

export default SettingsPanel
